import { I18n } from '@calendly/i18n'

import { EventLink } from 'components/event_type_edit'
import { useEventType } from 'features/event_type_provider'

import { PanelContentContainer, PanelContentHeader, PanelContentTitle } from '../styles'

export const BookingLink = ({ isLocked }) => {
  const eventType = useEventType()
  const { isShared } = eventType

  if (isShared) return null

  const profileSlug = eventType.profile?.slug

  return (
    <PanelContentContainer section>
      <PanelContentHeader>
        <PanelContentTitle>
          {I18n.t('publisher.event_type_editor.sections.more_options.booking_link.helper_text')}
        </PanelContentTitle>
        <EventLink isLocked={isLocked} profileSlug={profileSlug} />
      </PanelContentHeader>
    </PanelContentContainer>
  )
}
